import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { mediaQuery } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';

export const AttributionTextContainer = styled(Stack)`
  &.sm-text-align-center {
    ${mediaQuery(
      'sm',
      css`
        .author-name,
        .author-title {
          text-align: center;
        }
      `
    )}
  }
`;
